import { defineWave } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   BLOC A — la montée. Signature de mouvement : BALAYAGE LATÉRAL.

   Chaque bloc d'un niveau porte une signature de mouvement distincte
   (PLAN.md §6.11). Le joueur doit SENTIR la variation sans pouvoir la nommer :
   c'est ce qui empêche un niveau de « se fondre en bouillie » après une minute.

   Règle appliquée partout : les couloirs 0 et 6 sont des pièges de bord,
   interdits aux ennemis de plus de 200 PV — le registre le vérifie et fait
   échouer le build.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineWave({
  id: 'a1-nuee',
  duration: 12,
  spawns: [
    // Nuée de popcorn qui balaie de gauche à droite. Aucun tir : le joueur
    // apprend d'abord que son propre tir est automatique.
    { at: 0.0, enemy: 'mite', lane: 1, count: 5, spacing: 0.08 },
    { at: 1.4, enemy: 'mite', lane: 2, count: 5, spacing: 0.08 },
    { at: 2.8, enemy: 'mite', lane: 3, count: 6, spacing: 0.08 },
    { at: 4.2, enemy: 'mite', lane: 4, count: 5, spacing: 0.08 },
    { at: 5.6, enemy: 'mite', lane: 5, count: 5, spacing: 0.08 },
    // Retour en sens inverse : la même figure lue à l'envers se reconnaît, et
    // la reconnaissance est ce qui transforme un obstacle en rythme.
    { at: 7.5, enemy: 'mite', lane: 4, count: 6, spacing: 0.07 },
    { at: 8.9, enemy: 'mite', lane: 3, count: 6, spacing: 0.07 },
    { at: 10.3, enemy: 'mite', lane: 2, count: 6, spacing: 0.07 },
  ],
});
